import moment from "moment";
import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import {
  postRegattaForms,
  submitRegattaForms,
} from "../../redux/actions/regattaActions";

const RetunToWork = ({
  appData,
  postRegattaFormsFunc,
  submitRegattaFormsFunc,
}) => {
  const { firstName = "", lastName = "" } = appData;

  const initialState = {
    from: {
      title: "First date of absence (DD/MM/YYYY)",
      type: "date",
      mandatory: true,
    },
    to: {
      title: "Return to work date (DD/MM/YYYY)",
      type: "date",
      mandatory: true,
    },
    statement1: {
      title:
        "I believe I am fit to return to work. I understand I must declare all medication that could have an impact on mine as well as others safety, particularly if I drive a MHE.*",
      type: "singlecheckbox",
      mandatory: true,
    },
    statement2: {
      title:
        "I understand I may be asked more questions in order to fully assess my ability to work.*",
      type: "singlecheckbox",
      mandatory: true,
    },
    statement3: {
      title:
        "I understand on rare occasions, decisions about my deployment to the Regatta contract may be made on the information provided.*",
      type: "singlecheckbox",
      mandatory: true,
    },
    name: {
      title: "Name",
      value: `${firstName} ${lastName}`,
      type: "text",
      mandatory: true,
      disabled: true,
    },
    signature: {
      title: "Signature",
      value: `${firstName} ${lastName}`,
      type: "text",
      mandatory: true,
      disabled: true,
    },
    date: {
      title: "Date",
      value: moment(new Date()).format("DD/MM/YYYY"),
      type: "text",
      mandatory: true,
      disabled: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const submitForm = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postRegattaFormsFunc("ReturnToWork", {
      // save to JSON so that the medication upload can be shown if required tickbox is checked.
      [new Date(Date.now()).toISOString()]: { ...fieldValuesPayload },
    });

    submitRegattaFormsFunc(
      "ReturnToWork",
      {
        [new Date(Date.now()).toISOString()]: { ...fieldValuesPayload },
      },
      "YRG1"
    );

    history.push("/profile/edit/regatta-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Return To Work"}
      fields={fields}
      setField={setField}
      handleCancel={() => history.push("/profile/edit/regatta-onboarding")}
      onboardingBranch={"Regatta"}
      handleSingleSubmit={submitForm}
      handleSubmit={submitForm} // handles save to JSON
      useSubmitText={true}
      submitDisabled={moment(fields.from.value).isAfter(
        moment(fields.to.value)
      )}
      customHtml={
        moment(fields.from.value).isAfter(moment(fields.to.value)) && (
          <p
            style={{
              color: "red",
              display: "flex",
              justifyContent: "end",
              fontSize: "12px",
            }}
          >
            `First date of absence` is selected after `Return to work date`.
          </p>
        )
      }
    />
  );
};

RetunToWork.propTypes = {
  appData: any,
  postRegattaFormsFunc: func.isRequired,
  submitRegattaFormsFunc: func.isRequired,
};

const mapDispatchToProps = {
  postRegattaFormsFunc: postRegattaForms,
  submitRegattaFormsFunc: submitRegattaForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(RetunToWork);
